export default __webpack_public_path__ + "static/media/logout.cb1ff83d.svg";